import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import BarLineChartTemplate from 'Pages/Analytics/SaleAnalytics/Components/BarLineChart.Template'
import { getStore360Charts } from 'Services/Analytics/saleChannel-analytics'
import BarChartTemplate from 'Pages/Analytics/SaleAnalytics/Components/BarChart.Template'

const ChartRow4 = () => {
  const { id } = useParams()
  return (
    <>
      <div className="bg-white p-4 col-span-1 shadow-div_b">
        <div className="mb-4 font-semibold">{`Customer and Payment Method (By Frequency)`}</div>
        <div className="w-full overflow-y-scroll overflow-x-hidden" style={{ height: 260 }}>
          <BarLineChartTemplate
            chartCode="customer_and_payment_method"
            handleDataFunction={getStore360Charts}
            isHalf
          />
        </div>
      </div>
      <div className="bg-white p-4 col-span-1 shadow-div_b">
        <div className="mb-4 font-semibold">Total Customer by Sale Channel</div>
        <div className="w-full overflow-y-scroll overflow-x-hidden" style={{ height: 260 }}>
          <BarChartTemplate
            chartCode="total_customer_by_sale_channel"
            handleDataFunction={getStore360Charts}
            isStacked
            store_id={id}
          />
        </div>
      </div>
    </>
  )
}

export default ChartRow4
